import { useState } from 'react'
import { Button } from '@astryxdesign/core/Button'
import { Card } from '@astryxdesign/core/Card'
import { Stack } from '@astryxdesign/core/Stack'
import { Table, proportional } from '@astryxdesign/core/Table'
import { TextInput } from '@astryxdesign/core/TextInput'
import { Text } from '@astryxdesign/core/Text'
import { Heading } from '@astryxdesign/core/Heading'

// The cascade-layer smoke test, kept rather than thrown away.
//
// A broken @layer order does not raise anything. It fails silently, the same
// way, on every page at once: components keep their class names, the browser
// keeps serving the stylesheet, and the padding is simply gone. The failure
// mode Astryx's migration guide names first is an app reset or a CSS framework
// left unlayered, which then outranks every component style no matter how
// specific it is - and Bulma is exactly that, still in this app while the
// views are rebuilt one at a time.
//
// So this page renders a handful of primitives whose styling is load-bearing
// and obvious when absent. The guide suggests a throwaway page; this one is a
// route instead, because the question "is the cascade sound?" is worth being
// able to ask of a real deployed build and not only of a dev server. It is the
// difference between diagnosing this in one look and bisecting six screens.
//
// It is checked in a browser, not in jsdom: jsdom does not apply imported
// stylesheets, so getComputedStyle would report 0px here whether the cascade
// is sound or not. See the assertion in scripts/foundation-check.mjs.
export function FoundationCheck() {
    const [email, setEmail] = useState('')

    return (
        <div data-foundation-check>
            <Stack gap={4} padding={4} maxWidth={640}>
                <Heading level={1}>Foundation check</Heading>
                <Text as="p" type="supporting">
                    The button needs visible padding and a filled background;
                    the input and the card need borders and inner spacing. If
                    any of that is missing, the layer order is wrong - start at
                    src/layers.css.
                </Text>

                <Button label="Primary action" variant="primary" />

                <TextInput
                    label="Email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={setEmail}
                />

                <Card>One card with default padding</Card>

                <Table
                    data={[{ name: 'Foundation', status: 'ok' }]}
                    columns={[
                        { key: 'name', header: 'Name', width: proportional(1) },
                        { key: 'status', header: 'Status', width: proportional(1) },
                    ]}
                    idKey="name"
                />
            </Stack>
        </div>
    )
}

export default FoundationCheck
